import { gql } from '@apollo/client'
import productsFieldsQuery from '../../commons/fields/products'

/**
 * Gets the string for `alternativeProductsQuery` query.
 * Returns the "Opciones similares" (similar options) products for the
 * SKUs displayed on the product-detail page.
 * @internal
 */

const alternativeProductsQuery = gql`
  query AlternativeProducts(
    $storefrontName: String!,
    $sessionUid: ID!,
    $skus: [String!]!
  ) {
    alternativeProducts(
      storefrontName: $storefrontName,
      sessionUid: $sessionUid,
      skus: $skus
    ) {
      ${productsFieldsQuery}
    }
  }
`

export default alternativeProductsQuery
